// Umami analytics loader — injected ONLY when a real website id is configured
// (VITE_UMAMI_WEBSITE_ID). This replaces the old hardcoded <UMAMI_WEBSITE_ID>
// placeholder that fired gateway.umami.is/api/send -> HTTP 400 on every load.
// Umami auto-captures the referrer (needed to detect chatgpt.com / perplexity.ai
// GEO referrals). It runs alongside — never replaces — the /api/track events.
export function loadUmami() {
  const id = import.meta.env.VITE_UMAMI_WEBSITE_ID
  if (!id || typeof document === 'undefined') return
  const src = import.meta.env.VITE_UMAMI_SRC || 'https://cloud.umami.is/script.js'
  if (document.querySelector(`script[data-website-id="${id}"]`)) return
  const s = document.createElement('script')
  s.defer = true
  s.src = src
  s.setAttribute('data-website-id', id)
  document.head.appendChild(s)
}
